import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98d522a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-section" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "custom-control custom-checkbox" }
const _hoisted_4 = {
  class: "custom-control-label",
  for: "terms-of-purchase"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" This item requires freight shipping ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_editor = _resolveComponent("vue-editor")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_vue_editor, {
        modelValue: _ctx.store.productDetails,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.store.productDetails) = $event))
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "custom-control-input",
              id: "terms-of-purchase",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.store.freightShipping) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.store.freightShipping]
            ]),
            _hoisted_5
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeTab('prev'))),
        class: "tabs-actions btn btn-secondary"
      }, "Prev"),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChangeTab('next'))),
        class: "tabs-actions btn btn-secondary"
      }, "Next")
    ])
  ]))
}